import API from '@/api';
import V3API from '@/api/v3';
import { formatGameModeKey, isDev } from '@/utils/helpers';

const GET_EVENTS = 'GET_EVENTS';
const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
const GET_EVENTS_FAILED = 'GET_EVENTS_FAILED';
const RESET_EVENTS = 'RESET_EVENTS';

const GET_CLUBHOUSE_EVENTS = 'GET_CLUBHOUSE_EVENTS';
const GET_CLUBHOUSE_EVENTS_SUCCESS = 'GET_CLUBHOUSE_EVENTS_SUCCESS';
const GET_CLUBHOUSE_EVENTS_FAILED = 'GET_CLUBHOUSE_EVENTS_FAILED';
const RESET_CLUBHOUSE_EVENTS = 'RESET_CLUBHOUSE_EVENTS';

const SHOW_EVENT = 'SHOW_EVENT';
const SHOW_EVENT_SUCCESS = 'SHOW_EVENT_SUCCESS';
const SHOW_EVENT_FAILED = 'SHOW_EVENT_FAILED';

const CREATE_EVENT = 'CREATE_EVENT';
const CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
const CREATE_EVENT_FAILED = 'CREATE_EVENT_SUCCESS';

const DELETE_EVENT = 'DELETE_EVENT';
const DELETE_EVENT_FAILED = 'DELETE_EVENT_FAILED';
const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';

const UPDATE_EVENT = 'UPDATE_EVENT';
const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
const UPDATE_EVENT_FAILED = 'UPDATE_EVENT_FAILED';

const GET_EVENT_LEADERBOARD = 'GET_EVENT_LEADERBOARD';
const GET_EVENT_LEADERBOARD_SUCCESS = 'GET_EVENT_LEADERBOARD_SUCCESS';
const GET_EVENT_LEADERBOARD_FAILED = 'GET_EVENT_LEADERBOARD_FAILED';

const UPDATE_EVENT_LEADERBOARD = 'UPDATE_EVENT_LEADERBOARD';
const UPDATE_EVENT_LEADERBOARD_SUCCESS = 'UPDATE_EVENT_LEADERBOARD_SUCCESS';
const UPDATE_EVENT_LEADERBOARD_FAILED = 'UPDATE_EVENT_LEADERBOARD_FAILED';

const SET_EVENT = 'SET_EVENT';
const SET_EVENT_FAILED = 'SET_EVENT_FAILED';
const RESET_EVENT_STATE = 'RESET_EVENT_STATE';
const SET_EVENT_DETAILS = 'SET_EVENT_DETAILS';
const SET_GAME_MODE = 'SET_GAME_MODE';
const SET_GAME_MODE_EDITABLE = 'SET_GAME_MODE_EDITABLE';
const SET_COURSE = 'SET_COURSE';
const CLEAR_SELECTED_COURSE = 'CLEAR_SELECTED_COURSE';
const SET_SELECTED_HOLES = 'SET_SELECTED_HOLES';
const SET_SELECTED_HOLE_NUMBERS = 'SET_SELECTED_HOLE_NUMBERS';
const CLEAR_SELECTED_HOLES = 'CLEAR_SELECTED_HOLES';
const SET_GAME_ADDITIONAL_INFORMATION = 'SET_GAME_ADDITIONAL_INFORMATION';
const SET_MEMBERS_SELECTED = 'SET_MEMBERS_SELECTED';
const TOTAL_EVENTS = 'TOTAL_EVENTS';
const TOTAL_CURRENT_EVENTS = 'TOTAL_CURRENT_EVENTS';

const GET_EVENT_SURVEY_LIST = 'GET_EVENT_SURVEY_LIST';
const GET_EVENT_SURVEY_LIST_FAILED = 'GET_EVENT_SURVEY_LIST_FAILED';
const GET_EVENT_SURVEY_LIST_SUCCESS = 'GET_EVENT_SURVEY_LIST_SUCCESS';

const GET_EVENT_DATA = 'GET_EVENT_DATA';
const GET_EVENT_DATA_FAILED = 'GET_EVENT_DATA_FAILED';
const GET_EVENT_DATA_SUCCESS = 'GET_EVENT_DATA_SUCCESS';

// MM:SS
function timeToSecondsFromMin(timeStr) {
  const [minutes, seconds] = timeStr.split(':');
  return parseInt(minutes) * 60 + parseInt(seconds);
}

// HH:MM
function timeToSecondsFromHours(timeStr) {
  const [hours, minutes] = timeStr.split(':');
  return parseInt(hours) * 3600 + parseInt(minutes) * 60;
}
// HH:MM
function timeToMinutes(timeStr) {
  const [hours, minutes] = timeStr.split(':');
  return parseInt(hours) * 60 + parseInt(minutes);
}

// Enabled the module to be namespaced
const namespaced = true;

// Event initial state
const state = {
  all: [],
  clubhouseAll: [],
  eventDetailsLeaderboard: [],
  loading: false,
  loadingLeaderboard: false,
  loadingClubEvents: false,

  gameModeEditable: false,
  gameMode: '',

  eventDetails: {},
  event: {},
  createdEvent: {},
  courseSelected: {},
  holesSelected: [],
  holeNumberSet: [],
  gameAdditionalInformation: {},
  membersSelected: [],
  // teamsSelected: [],
  totalEvents: 0,
  totalCurrentEvents: 0,
  generalLoading: false,
  eventSurveyList: [],
};

const emptyState = {
  all: [],
  clubhouseAll: [],
  loading: false,
  gameModeEditable: false,
  gameMode: '',
  eventDetails: {},
  event: {},
  createdEvent: {},
  courseSelected: {},
  holesSelected: [],
  holeNumberSet: [],
  gameAdditionalInformation: {},
  membersSelected: [],
  // teamsSelected: [],
  totalEvents: 0,
  totalCurrentEvents: 0,
  generalLoading: false,
  eventSurveyList: [],
};

// //! Use to enable new events list setup
// const enableApexEvents = false;

// Event getters
const getters = {
  list: (state) => {
    return state.all;
  },

  listAll: (state) => {
    return state.all;
  },

  listUserEvents: (state) => {
    // const filteredEvents = state?.all?.filter((item) => {
    //   return enableApexEvents ? item : item?.game === 'connect';
    // });
    // return process.env.NODE_ENV === 'production' &&
    //   (process.env.VUE_APP_SITE_ENV !== 'staging' || process.env.VUE_APP_SITE_ENV !== 'qa') &&
    //   !isDev()
    //   ? filteredEvents
    //   : state.all;
    return state.all;
  },

  listAllCH: (state) => {
    return state.clubhouseAll;
  },

  details: (state) => {
    return state.eventDetails;
  },

  leaderboard: (state) => {
    return state.eventDetailsLeaderboard;
  },

  loading: (state) => {
    return state.loading;
  },

  loadingClubEvents: (state) => {
    return state.loadingClubEvents;
  },

  loadingLeaderboard: (state) => {
    return state.loadingLeaderboard;
  },

  gameModeEditable: (state) => {
    return state.gameModeEditable;
  },

  getGameMode: (state) => {
    return state.gameMode;
  },

  getEvent: (state) => {
    return state.event;
  },

  getEventDetails: (state) => {
    return state.eventDetails;
  },

  getCourse: (state) => {
    return state.courseSelected;
  },

  getSelectedHoles: (state) => {
    return state.holesSelected;
  },

  getGameAdditionalInformation: (state) => {
    return state.gameAdditionalInformation;
  },

  membersSelected: (state) => {
    return state.membersSelected;
  },

  // teamsSelected: state => state.teamsSelected,

  getHoleNumberSet: (state) => {
    return state.holeNumberSet;
  },

  totalEvents: (state) => {
    return state.totalEvents;
  },

  generalLoading: (state) => {
    return state.generalLoading;
  },

  getEventSurveyList: (state) => {
    return state.eventSurveyList;
  },
};

// Event actions
const actions = {
  /**
   * list fetches the event list for a user from the API
   */
  async list({ commit }, timeline) {
    let response;

    commit(GET_EVENTS);
    //* reset event list before fetching new events
    commit(RESET_EVENTS);

    try {
      response = await API.events.list(timeline);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_EVENTS_FAILED);
        reject(response);
      } else {
        commit(GET_EVENTS_SUCCESS, response.data);
        // Return GET data within promise
        resolve(response.data);
      }
    }).catch((err) => {
      return console.log('error', err);
    });
  },

  /**
   * listAll fetches all the events from the API
   */
  async listAll({ commit }, timeline) {
    let response;
    let eventClubhouseResponse;

    commit(GET_EVENTS);
    //* reset event list before fetching new events
    commit(RESET_EVENTS);

    try {
      response = await API.events.listAll(timeline);

      commit(TOTAL_EVENTS, response.data.totalEvents);

      //* This works and renders correct list!!
      eventClubhouseResponse = await Promise.all(
        response?.data?.map(async (event) => {
          if (event.clubhouseID !== undefined) {
            const clubhouseResponse = await API.clubhouses.show(event.clubhouseID);
            return Object.assign(event, { clubhouse: clubhouseResponse.data });
          }
        })
      );

      //* Leaving the below examples for the time being so I don't forget them
      //* The can be removed though

      //* does not work but renders correct filtered list items
      // response.data.forEach(async event => {
      //   clubhouseResponse = await API.clubhouses.show(event.clubhouseID)
      //   event.clubhouse = clubhouseResponse.data
      // })

      //* works but renders all items in past list
      // for (let i = 0; i < eventResponse.data.length; i++) {
      //   clubhouseResponse = await API.clubhouses.show(eventResponse.data[i].clubhouseID)
      //   eventResponse.data[i].clubhouse = clubhouseResponse.data
      // }

      //* works but renders all items in past list
      // for (const event of eventResponse.data) {
      //   clubhouseResponse = await API.clubhouses.show(event.clubhouseID)
      //   event.clubhouse = clubhouseResponse.data
      // }
      // console.log(eventResponse)

      response.data = eventClubhouseResponse;
    } catch (err) {
      return new Promise((resolve, reject) => {
        commit(SHOW_EVENT_FAILED);
        reject(err);
      });
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_EVENTS_FAILED);
        reject(response);
      } else {
        commit(GET_EVENTS_SUCCESS, response.data);
        // Return GET data within promise
        resolve(response.data);
      }
    }).catch((err) => {
      return console.log('error', err);
    });
  },

  /**
   * listParticipated fetches all the users events from the API
   */
  async listParticipated({ commit }, payload) {
    let response;
    let eventClubhouseResponse;

    //* id = userid
    //* timeline = past, present, future
    const { id, timeline } = payload;

    commit(GET_EVENTS);
    //* reset event list before fetching new events
    commit(RESET_EVENTS);

    try {
      response = await API.events.listParticipated(id, timeline);

      commit(TOTAL_EVENTS, response.totalEvents);

      if (!response.data || !Array.isArray(response.data)) {
        commit(SHOW_EVENT_FAILED);
        return;
      }

      //* This works and renders correct list!!
      eventClubhouseResponse = await Promise.all(
        response.data.map(async (event) => {
          if (event.event?.clubhouseID !== undefined) {
            const clubhouseResponse = await API.clubhouses.show(event.event.clubhouseID);
            return Object.assign(event.event, {
              clubhouse: clubhouseResponse.data,
            });
          }
        })
      );

      //* Leaving the below examples for the time being so I don't forget them
      //* The can be removed though

      //* does not work but renders correct filtered list items
      // response.data.forEach(async event => {
      //   clubhouseResponse = await API.clubhouses.show(event.clubhouseID)
      //   event.clubhouse = clubhouseResponse.data
      // })

      //* works but renders all items in past list
      // for (let i = 0; i < eventResponse.data.length; i++) {
      //   clubhouseResponse = await API.clubhouses.show(eventResponse.data[i].clubhouseID)
      //   eventResponse.data[i].clubhouse = clubhouseResponse.data
      // }

      //* works but renders all items in past list
      // for (const event of eventResponse.data) {
      //   clubhouseResponse = await API.clubhouses.show(event.clubhouseID)
      //   event.clubhouse = clubhouseResponse.data
      // }
      // console.log(eventResponse)

      response.data = eventClubhouseResponse;
    } catch (err) {
      return new Promise((resolve, reject) => {
        commit(SHOW_EVENT_FAILED);
        reject(err);
      });
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_EVENTS_FAILED);
        reject(response);
      } else {
        commit(GET_EVENTS_SUCCESS, response.data);
        // Return GET data within promise
        resolve(response.data);
      }
    }).catch((err) => {
      return console.log('error', err);
    });
  },

  // * show fetches the event details for given id from the API
  async show({ commit }, { id, overrideCache = false }) {
    let response = {};
    let eventResponse;
    let courseResponse;
    let clubhouseResponse;

    commit(SHOW_EVENT);

    try {
      eventResponse = await API.events.show(id, overrideCache);
      //* events are now viewable unauthenticated. Only event/id endpoint is open but pulls
      //* in course and clubhouse data in one call
      // courseResponse = await API.courses.show(eventResponse?.data?.courseID);
      // clubhouseResponse = await API.clubhouses.show(eventResponse?.data?.clubhouseID);

      if (eventResponse) {
        response = eventResponse?.data;
      }
      // if (courseResponse) {
      //   response.course = courseResponse?.data;
      // }
      // if (clubhouseResponse) {
      //   response.clubhouse = clubhouseResponse?.data;
      // }
      // console.log('response:', response);
      if (response?.course?.image_url) {
        response.course.imageURL = response?.course?.image_url;
      }

      return new Promise((resolve, reject) => {
        commit(SHOW_EVENT_SUCCESS, response);
        resolve(response);
      });
    } catch (err) {
      console.error('error:', err);
      return new Promise((resolve, reject) => {
        commit(SHOW_EVENT_FAILED);
        reject(err);
      });
    }
  },

  /**
   * create an event from the given payload
   */
  async create({ commit }, payload) {
    let response = {};

    commit(CREATE_EVENT);

    try {
      response = await API.events.create(payload);

      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          commit(CREATE_EVENT_FAILED);
          reject(response);
        } else {
          commit(CREATE_EVENT_SUCCESS);
          resolve(response);
        }
      });
    } catch (err) {
      return new Promise((resolve, reject) => {
        commit(CREATE_EVENT_FAILED);
        reject(err);
      });
    }
  },

  //* create an APEX event from the given payload
  async apexEventCreate({ commit }, { payload = {}, eventInfo = {} }) {
    // console.log('apexEventCreate store payload:', payload);
    // console.log('apexEventCreate store eventInfo:', eventInfo);
    let response = {};

    commit(CREATE_EVENT);

    const { eventDetails, gameInfo, courseInfo } = eventInfo;
    const {
      name,
      ownerId,
      clubhouseID,
      courseID,
      elevation,
      elevation_setting,
      startsAt,
      endsAt,
      participants,
      fairwayHardness,
      gender,
      greenHardness,
      holeSet,
      apexHoleSet,
      handicapMax,
      handicapMin,
      playerMaximum,
      teeOptions,
      trackingSystems,
      mulliganSetting,
      playerFinishPutt,
      pinSet,
      teamsRequired,
      stimpRating,
      state,
      course,
      extra,
      apexSettings,
    } = payload;

    // Compensate and adjust the pin set to be 1 based
    const apexFormattedPinSet = pinSet?.map((pin) => {
      return pin + 1;
    });

    const formattedGameModeID = formatGameModeKey(eventDetails?.eventTypes);
    // console.log('formattedGameModeID:', formattedGameModeID);

    // Calculate the mulligan setting string value based on mulligans value entered
    const mulliganSettingString =
      gameInfo.mulligans?.value === 0
        ? 'disabled'
        : gameInfo?.mulligans?.value === 11
        ? 'infinite'
        : 'limited';
    // console.log('mulliganSettingString:', mulliganSettingString);

    // Calculate turn duration in seconds from turn duration value formatted like MM:SS
    const turnDurationSeconds = timeToSecondsFromMin(courseInfo.turnDuration);
    // console.log('turnDurationSeconds:', turnDurationSeconds);

    // Calculate match hours/minutes from format like HH:MM
    const calcMatchTimeMinutes = timeToMinutes(courseInfo.matchTime);
    // console.log('calcMatchTimeMinutes:', calcMatchTimeMinutes);

    const apexEventPayload = {
      event: {
        access: 'public', // 'public', 'private'
        clubhouse_id: clubhouseID, // "5d94bcca-b032-49dc-acac-8584549b1a10"
        creator_id: ownerId,
        ends_at: endsAt, // '2025-02-13T23:59:00-07:00', "2025-02-11T01:53:10.697Z"
        gender: gender === 'all' ? null : gender, // if all send null, male, female, undisclosed
        handicap_max: handicapMax, // 54
        handicap_min: handicapMin, // -20
        handicap_type: 'clubhouse', // clubhouse, none, user
        invited_users: participants, // [array of user ids]
        name, // 'Name of Event'
        player_max: playerMaximum,
        starts_at: startsAt, // '2025-02-06T00:01:00-07:00'
        status: state === 'published' ? 'published' : 'draft', // 'published', needs active or disabled, will change to published, disabled, and draft
        survey_id: apexSettings?.survey_id || null,
        teams_required: !teamsRequired ? null : teamsRequired, // false, needs 2, number or null // TODO need to handle this
        tournament_id: null, // TODO update when set up
        tracking_systems_allowed: trackingSystems, // needs ['trugolf_apogee', 'ernest_sports']
      },
      game_settings: {
        atmosphere_cloud_cover: gameInfo?.apexAtmosphereCloudCover, // 'overcast', options clear, partly_cloudy, cloudy, overcast
        atmosphere_fog: gameInfo?.apexAtmosphereFog, // 'on' or off, default off
        atmosphere_precipitation: gameInfo?.apexAtmospherePrecipitation, // 'rain_drizzle', options none, rain_drizzle, rain_light, rain_moderate, rain_downpour, snow_flurries, snow_light, snow_moderate, snow_blizzard
        atmosphere_time: gameInfo?.apexAtmosphereTime, // 'morning', options sunrise, morning, afternoon, sunset
        attempts: extra.Attempts, // 3
        auto_caddie: gameInfo?.apexAutoCaddie, // on or off
        auto_continue_seconds: gameInfo?.apexAutoContinueSeconds, // 8, int in seconds
        auto_drop_rehit: gameInfo?.apexAutoDropRehit, // 'on' or off, default off
        auto_flybys: gameInfo?.apexAutoFlybys, // false, need 'on' or 'off', default off
        ball_indicator_type: 'shot_length', // 'shot_length' only value currently, will add more later
        commentary_enabled: gameInfo?.apexAICommentary, // needs 'off' or 'on', default off
        course_id: courseID,
        course_version_id: course.id, // this is the version id on the course object, seriesUUID is the course id
        custom_elevation: elevation_setting !== 'course' ? elevation : null, // '12345.365', only if custom elevation
        difficulty: 'none', // easy, medium, hard, all, none, default none // TODO see if this is needed for KTP
        elevation_setting: gameInfo?.elevation?.elevation_setting, // needs "course", "custom", default course
        fairway_hardness: fairwayHardness?.toLowerCase(), // Moderate, needs "soft", "moderate", "hard"
        game_mode_id: formattedGameModeID, // ClosestToPin - needs stroke_play format, 'stroke_play'
        gimme_distance: null, // stroke play, 'gimme_inside_3_feet', default null (optional) // TODO need to format
        green_hardness: greenHardness?.toLowerCase(), // Moderate, needs "soft", "moderate", "hard"
        holes_to_play: apexHoleSet, // [3, 4, 5], 1 based
        limited_mulligans: mulliganSetting, // 5, needs the number 12
        match_timer_minutes: calcMatchTimeMinutes, // 30 Int
        match_type: 'event', // default to online, needs online = pvp, "event", "local"
        mulligan_setting: mulliganSettingString, // 5, needs "disabled", "infinite", "limited"
        pins_to_play: apexFormattedPinSet, // [3], single value array, 1 based
        players_finish_putt: playerFinishPutt ? 'on' : 'off', // stroke play, false, needs 'off' or 'on', default off
        putting_line: gameInfo?.apexPuttingLine, // stroke play, needs 'play_break', align_break, off, default off
        putting_mode: null, // stroke play, needs "player_putts_out", "gimme", "computer_decides", "auto_scoring", "player_decides", "none", default null // TODO need to format
        putting_range: null, // stroke play, needs 91.3234, float ?? // TODO need to set
        stimp_rating: stimpRating, // 7, same as stimp rating
        tee_options: teeOptions?.map((tee) => {
          return tee?.toLowerCase();
        }), // ['Black'], needs ['black']
        terrain_penalty: gameInfo?.terrainPenalty?.toLowerCase(), // 1, needs 'on' or 'off', default on
        turn_timer_seconds: turnDurationSeconds, // 3, needs 300 int
        victory_score: null, // score to win optional, float
        wind_speed: gameInfo?.apexWind, // 'Course Wind', needs "windy", "breezy", "calm", "course", "strong", "none", default course
      },
    };
    console.log('apexEventPayload:', apexEventPayload);

    try {
      response = await V3API.events.apexEventCreate(apexEventPayload);
      // console.log('apex create event store response:', response);

      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          commit(CREATE_EVENT_FAILED);
          reject(response);
        } else {
          commit(CREATE_EVENT_SUCCESS, response.data);
          resolve(response.data);
        }
      });
    } catch (err) {
      return new Promise((resolve, reject) => {
        commit(CREATE_EVENT_FAILED);
        reject(err);
      });
    }
  },

  // * apexEventGet fetches the apex event details for given id from the API
  // @ should be publicly accessible
  async apexEventGet({ commit }, payload) {
    let response = {};

    commit(SHOW_EVENT);

    try {
      response = await V3API.events.apexEventGet(payload);

      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          commit(SHOW_EVENT_FAILED);
          reject(response);
        } else {
          commit(SHOW_EVENT_SUCCESS, response.data);
          resolve(response.data);
        }
      });
    } catch (err) {
      console.error('error:', err);
      return new Promise((resolve, reject) => {
        commit(SHOW_EVENT_FAILED);
        reject(err);
      });
    }
  },

  // * apexUserEventList fetches a list of user Events (Connect/Apex)
  // @ Filter response based on timeline value passed in
  // @ past, active, available for users
  async apexUserEventList({ commit }, timeline) {
    let response = {};

    commit(GET_EVENTS);

    //* reset event list before fetching new events
    commit(RESET_EVENTS);

    try {
      response = await V3API.events.apexUserEventList(timeline);

      const totalEvents = response?.data ? response.data.length : 0;

      if (response?.data?.length) {
        response.data = response?.data?.filter((event) => {
          return event.timeline === timeline && event.status === 'published';
        });
      }

      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          commit(GET_EVENTS_FAILED);
          reject(response);
        } else {
          commit(GET_EVENTS_SUCCESS, response.data);
          commit(TOTAL_EVENTS, totalEvents);
          resolve(response.data);
        }
      });
    } catch (err) {
      console.error('error:', err);
      return new Promise((resolve, reject) => {
        commit(GET_EVENTS_FAILED);
        reject(err);
      });
    }
  },

  // * apexClubhouseEventList fetches a list of clubhouse Events (Connect/Apex)
  // @ Filter response based on timeline value passed in
  // @ past, active, available for users
  async apexClubhouseEventList({ commit }, payload = {}) {
    // console.log('apexClubhouseEventList payload:', payload);
    let response = {};
    const { timeline } = payload;

    commit(GET_CLUBHOUSE_EVENTS);
    // //* reset event list before fetching new events
    commit(RESET_CLUBHOUSE_EVENTS);

    try {
      response = await V3API.events.apexClubhouseEventList(payload);
      // console.log('clubhouse list response:', response.data);

      const totalEvents = response?.data ? response.data.length : 0;
      // console.log('totalEvents:', totalEvents);

      if (
        !response ||
        response?.data === null ||
        response?.data === '' ||
        response?.data === undefined
      ) {
        commit(GET_CLUBHOUSE_EVENTS_FAILED);
        response = {
          data: [],
          status: 204,
          totalEvents: 0,
        };
      }

      commit(TOTAL_EVENTS, totalEvents);

      if (response?.data?.length) {
        response.data = response?.data?.filter((event) => {
          if (timeline === 'disabled') {
            return event.status === timeline;
          }
          return (
            event.timeline === timeline &&
            (event.status === 'published' || event.status === 'draft')
          );
        });
      }

      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          commit(GET_CLUBHOUSE_EVENTS_FAILED);
          reject(response);
        } else {
          commit(GET_CLUBHOUSE_EVENTS_SUCCESS, response.data);
          // Return GET data within promise
          resolve(response.data);
        }
      }).catch((err) => {
        return console.log('error', err);
      });
    } catch (err) {
      console.error('error:', err);
      return new Promise((resolve, reject) => {
        commit(GET_CLUBHOUSE_EVENTS_FAILED);
        reject(err);
      });
    }
  },

  // * apexEventLeaderboard fetches the apex event details for given id from the API
  // @ should be publicly accessible
  async apexEventLeaderboard({ commit }, payload) {
    let response = {};

    commit(GET_EVENT_LEADERBOARD);

    try {
      response = await V3API.events.apexEventLeaderboard(payload);

      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          commit(GET_EVENT_LEADERBOARD_FAILED);
          reject(response);
        } else {
          commit(GET_EVENT_LEADERBOARD_SUCCESS, response.data);
          resolve(response.data);
        }
      });
    } catch (err) {
      console.error('error:', err);
      return new Promise((resolve, reject) => {
        commit(GET_EVENT_LEADERBOARD_FAILED);
        reject(err);
      });
    }
  },

  // * apexEventUpdate sets the event status to disabled
  // @ paylod is full event object with status set to disabled and id of event
  async apexEventUpdate({ commit }, payload) {
    let response = {};

    commit(DELETE_EVENT);

    try {
      response = await V3API.events.apexEventUpdate(payload);

      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          commit(DELETE_EVENT_FAILED);
          reject(response);
        } else {
          commit(DELETE_EVENT_SUCCESS, response.data);
          resolve(response.data);
        }
      });
    } catch (err) {
      console.error('error:', err);
      return new Promise((resolve, reject) => {
        commit(DELETE_EVENT_FAILED);
        reject(err);
      });
    }
  },

  // * apexEventSurveyList lists custom commentary options
  async apexEventSurveyList({ commit }) {
    let response = {};

    commit(GET_EVENT_SURVEY_LIST);

    try {
      response = await V3API.events.apexEventSurveyList();

      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          commit(GET_EVENT_SURVEY_LIST_FAILED);
          reject(response);
        } else {
          commit(GET_EVENT_SURVEY_LIST_SUCCESS, response.data);
          resolve(response.data);
        }
      });
    } catch (err) {
      console.error('error:', err);
      return new Promise((resolve, reject) => {
        commit(GET_EVENT_SURVEY_LIST_FAILED);
        reject(err);
      });
    }
  },

  // * apexEventEligible checks user eligibility for event
  async apexEventEligible({ commit }, payload) {
    let response = {};

    commit(GET_EVENT_DATA);

    try {
      response = await V3API.events.apexEventEligible(payload);

      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          commit(GET_EVENT_DATA_FAILED);
          reject(response);
        } else {
          commit(GET_EVENT_DATA_SUCCESS, response.data);
          resolve(response.data);
        }
      });
    } catch (err) {
      console.error('error:', err);
      return new Promise((resolve, reject) => {
        commit(GET_EVENT_DATA_FAILED);
        reject(err);
      });
    }
  },

  // * leaderboard fetches the leaderboard for an event by event id
  async leaderboard({ commit }, { id, overrideCache = false, sortScore = false, toggled = false }) {
    let response = {};

    commit(GET_EVENT_LEADERBOARD);

    try {
      response = await API.events.leaderboard(id, overrideCache, sortScore, toggled);

      if (response?.data?.leaders) {
        const newLeaders =
          (await Promise.all(
            response?.data?.leaders?.map(async (item) => {
              if (item.round_uuid !== undefined) {
                const roundResponse = await API.rounds.show({
                  id: item.round_uuid,
                  deleteCache: true,
                });
                const { holeSet = [], finalized = false } = roundResponse?.data;
                const lastHole = holeSet[holeSet.length - 1];
                return {
                  ...item,
                  finalized,
                  thru: finalized && item?.thru === lastHole + 1 ? 'F' : item?.thru,
                };
              }
              return item;
            })
          )) ?? [];
        response.data.leaders = newLeaders;
      }
    } catch (err) {
      console.error('err:', err);
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_EVENT_LEADERBOARD_FAILED);
        reject(response);
      } else {
        commit(GET_EVENT_LEADERBOARD_SUCCESS, response.data);
        resolve(response);
      }
    });
  },

  // * updateLeaderboardScore updates the score for a round on the leaderboard
  // @ {
  // @ 	"user_ids": ["3f1effe0-aeb1-4b7f-ad89-7ab0ced1e9f111"],
  // @   "round_id": "4f27dbb5-8dd0-4f4e-80fe-58055ff26a46111",
  // @   "edited_score": 12
  // @ }
  async updateLeaderboardScore({ commit }, payload) {
    let response = {};

    commit(UPDATE_EVENT_LEADERBOARD);

    try {
      response = await API.events.updateLeaderboardScore(payload);

      return new Promise((resolve, reject) => {
        commit(UPDATE_EVENT_LEADERBOARD_SUCCESS, response.data);
        resolve(response);
      });
    } catch (err) {
      return new Promise((resolve, reject) => {
        commit(UPDATE_EVENT_LEADERBOARD_FAILED);
        reject(err);
      });
    }
  },

  async clearLocalStorageEvents({ commit }) {
    let response = {};
    try {
      response = await API.events.clearLocal();

      return new Promise((resolve, reject) => {
        resolve(response);
      });
    } catch (err) {
      console.error(err);
    }
  },

  async resetEvent({ commit }) {
    commit(RESET_EVENT_STATE);
  },

  async setEvent({ commit }, event) {
    // console.log('event setEvent=======:', event);
    function camelCase(str) {
      return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
          return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, '');
    }

    // TODO Clean this up
    const {
      gender,
      puttingMode,
      teeBoxSelected,
      maximumHandicap,
      minimumHandicap,
      name,
      maxPlayers,
      eventStart,
      eventEnd,
      trackingSystemSelected,
      participation,
      allowGuest,
      playerFinishPutt,
      teamsRequired,
      handicapType = 'clubhouse',
      game,
      eventSurvey,
    } = event.eventDetails;
    const { attempts, turnDuration, pinDifficulty, difficulty } = event.courseInfo;
    const {
      autoFlybys,
      atmosphere,
      elevation,
      mulligans,
      stimpRating,
      wind,
      fairwayHardness,
      greenHardness,
      terrainPenalty,
    } = event.gameInfo;
    let puttingModeFormat = '';
    const offset = 1;

    const courseResponse = await API.courses.show(event.courseDetails?.seriesUUID);
    if (courseResponse?.status >= 400 || courseResponse?.data?.code === 'invalid_request') {
      return new Promise((resolve, reject) => {
        commit(SET_EVENT_FAILED);
        reject(new Error('Invalid Request Fetching Course'));
      });
    }

    const puttModeArr = puttingMode ? puttingMode.split(' ') : [];
    if (puttModeArr.includes('Gimme')) {
      puttModeArr[2] = 'Gimmie';
    }
    puttingModeFormat = camelCase(puttModeArr.join(''));

    switch (event.eventDetails.eventTypes) {
      case 'Closest To Pin':
        event.eventDetails.eventTypes = 'ClosestToPin';
        puttingModeFormat = '';
        break;
      case 'Closest to the Pin':
        event.eventDetails.eventTypes = 'ClosestToPin';
        puttingModeFormat = '';
        break;
      case 'Long Drive':
        event.eventDetails.eventTypes = 'LongestDrive';
        puttingModeFormat = '';
        break;
      case 'Longest Drive':
        event.eventDetails.eventTypes = 'LongestDrive';
        puttingModeFormat = '';
        break;
      case 'Long Drive - World Series':
        event.eventDetails.eventTypes = 'LongDriveWorldSeries';
        puttingModeFormat = '';
        break;
      case 'Scramble':
        event.eventDetails.eventTypes = 'Scramble';
        // Ensure Scramble has a valid puttingModeFormat, default to 'computerDecides' if empty
        if (!puttingModeFormat) {
          puttingModeFormat = 'computerDecides';
        }
        break;
      case 'Best Ball':
      case 'BestBall':
      case 'best ball':
      case 'best_ball':
      case 'bestball':
        event.eventDetails.eventTypes = 'BestBall';
        // Ensure Best Ball has a valid puttingModeFormat, default to 'computerDecides' if empty
        if (!puttingModeFormat) {
          puttingModeFormat = 'computerDecides';
        }
        break;
      case 'Blackout':
      case 'Solaro':
      case 'Blackout - Solaro':
      case 'Solaro - Blackout':
        puttingModeFormat = '';
        break;
      case 'Darts':
      case 'Henyett - Darts':
        puttingModeFormat = '';
        break;
      case 'Stroke Play':
      case 'stroke play':
      case 'stroke_play':
      case 'StrokePlay':
      case 'strokePlay':
        // Ensure Stroke Play has a valid puttingModeFormat, default to 'computerDecides' if empty
        if (!puttingModeFormat) {
          puttingModeFormat = 'computerDecides';
        }
        break;
      default:
        // For any other event types that support putting modes, ensure they have a valid value
        // Only set default if puttingModeFormat is empty (meaning puttingMode was missing/falsy)
        if (!puttingModeFormat) {
          // Check if this event type should support putting modes
          // If it's not one of the types that explicitly sets puttingModeFormat to '', use default
          puttingModeFormat = 'computerDecides';
        }
        break;
    }

    if (mulligans.value === 11) {
      mulligans.value = -1;
    }

    const formattedHCPType =
      handicapType?.toLowerCase() === 'global' ? 'user' : handicapType?.toLowerCase();

    const eventObj = {
      game,
      clubhouseID: event?.clubhouseID,
      courseID: event?.courseDetails?.seriesUUID,
      course: courseResponse?.data,
      elevation: elevation?.value,
      endsAt: eventEnd,
      atmosphere,
      autoFlybys: autoFlybys === 'Enabled',
      extra: {
        Attempts: attempts,
        Difficulty: difficulty || '',
        pinDifficulty: event?.eventDetails?.eventTypes === 'LongestDrive' ? '' : pinDifficulty,
        TurnDuration: turnDuration ? turnDuration?.split(':')[0] : '',
        RequiredSharedVariables: {
          Attempts:
            event?.eventDetails?.eventTypes === 'Blackout' ||
            event?.eventDetails?.eventTypes === 'Solaro' ||
            event?.eventDetails?.eventTypes === 'Darts'
              ? 5
              : 3,
          Difficulty: 'All',
          'Turn Duration': 3,
        },
      },
      participation,
      participants: event?.participants,
      // teams: event.teams,
      teamsRequired,
      fairwayHardness,
      gameMode: event?.eventDetails?.eventTypes?.split(' ').join(''),
      gender: gender.toLowerCase(),
      greenHardness,
      handicapMax: maximumHandicap,
      handicapMin: minimumHandicap,
      handicapType: formattedHCPType,
      // holeSet: event.holes,
      holeSet: event?.holeNumberSet,
      apexHoleSet: event?.holes?.map((hole) => {
        return hole.apexHoleNumber;
      }),
      mulliganSetting: mulligans?.value,
      name,
      ownerId: event?.ownerId,
      pinDifficulty,
      pinSet: [
        pinDifficulty !== undefined && event?.eventDetails?.eventTypes !== 'LongestDrive'
          ? Number(pinDifficulty.split(' ')[0]) - offset
          : undefined,
      ],
      playerCount: null,
      playerMaximum: maxPlayers,
      // puttingMode: puttingMode.split(' F').join('F').split(' G').join('G'),
      puttingMode: puttingModeFormat,
      scoringPenalty: terrainPenalty === 'On' ? 1 : 0, //* terrain penalty
      // scoringType, //* Remove, not sure what it's used for
      startsAt: eventStart,
      state: 'Not Published',
      stimpRating: stimpRating?.value,
      teeOptions: teeBoxSelected,
      // tournamentID: //@ this will be added later,
      trackingSystems: trackingSystemSelected,
      windSpeed: wind,
      // courseDetails: event.courseDetails,
      clubhouse: event?.clubhouse,
      allowGuest,
      playerFinishPutt,
      apexSettings: {
        ...event.gameInfo,
        survey_id: eventSurvey,
      },
    };

    // console.log('SET eventObj:', eventObj);
    commit(SET_EVENT, eventObj);
  },

  setEventDetails({ commit }, details) {
    commit(SET_EVENT_DETAILS, details);
  },

  gameModeSelected({ commit }, mode) {
    commit(SET_GAME_MODE, mode);
    commit(SET_GAME_MODE_EDITABLE);
  },

  courseSelected({ commit }, course) {
    commit(SET_COURSE, course);
  },

  clearSelectedCourse({ commit }) {
    commit(CLEAR_SELECTED_COURSE);
  },

  holesSelected({ commit }, holes) {
    commit(SET_SELECTED_HOLES, holes);
  },

  holeNumberSet({ commit }, holes) {
    commit(SET_SELECTED_HOLE_NUMBERS, holes);
  },

  clearSelectedHoles({ commit }) {
    commit(CLEAR_SELECTED_HOLES);
  },

  gameAdditionalInformation({ commit }, gameInfo) {
    commit(SET_GAME_ADDITIONAL_INFORMATION, gameInfo);
  },

  setMembersSelected({ commit }, members) {
    const membersArr = [];
    // const teamsArr = [];
    const userIdKey = 'user_uuid';
    // const teamKey = 'team';

    members.forEach((member) => {
      if (member && typeof member === 'string') {
        membersArr.push(member);
      } else {
        for (const key in member) {
          if (key === userIdKey) {
            // membersArr.push({ [userIdKey]: member[key] })
            membersArr.push(member[key]);
          }
          // else if (key === teamKey) {
          //   teamsArr.push(member[key]);
          // }
        }
      }
    });

    const payload = {
      membersArr,
      // teamsArr,
    };
    //* Only passes members id to participant list
    // commit(SET_MEMBERS_SELECTED, membersArr, teamsArr);

    //* Passes members id array and teams array to set lists
    commit(SET_MEMBERS_SELECTED, payload);
  },

  // * listAllCH fetches all the events from the API
  async listAllCH({ commit }, payload) {
    let response;
    // let eventClubhouseResponse
    let filteredClubhouse = [];
    const { id, timeline } = payload;

    commit(GET_CLUBHOUSE_EVENTS);
    //* reset event list before fetching new events
    commit(RESET_CLUBHOUSE_EVENTS);

    try {
      //! don't need to call the list at first, only call with actual uuid
      // response = await API.events.listClubhouseEvents(parseInt(id), timeline)

      // if (response.data === null || response.data === '') {
      //   commit(GET_CLUBHOUSE_EVENTS_FAILED)
      //   response.data = []
      // }
      // else {
      //   //* This works and renders correct list!!
      //   eventClubhouseResponse = await Promise.all(response.data.map(async event => {
      //     if (event.clubhouseID !== undefined) {
      //       let clubhouseResponse = await API.clubhouses.show(event.clubhouseID)
      //       return Object.assign(event, {clubhouse: clubhouseResponse.data})
      //     }
      //   }))
      // }

      let clubhouseList = await API.clubhouses.list();
      if (!clubhouseList) {
        clubhouseList = [];
      }

      filteredClubhouse = clubhouseList?.data?.filter((club) => {
        return parseInt(club.id) === parseInt(id);
      });

      if (filteredClubhouse[0]) {
        response = await API.events.listClubhouseEvents(filteredClubhouse[0].uuid, timeline);
      }

      // TODO have api adjusted to allow clubhouse id to be used as param
      // response = await API.events.listClubhouseEvents(parseInt(id), timeline);

      if (
        !response ||
        response?.data === null ||
        response?.data === '' ||
        response?.data === undefined
      ) {
        commit(GET_CLUBHOUSE_EVENTS_FAILED);
        response = {
          data: [],
          status: 204,
          totalEvents: 0,
        };
      }

      commit(TOTAL_EVENTS, response.totalEvents);

      //! This populated the whole clubhouse info, only need the name which is being sent now
      // //* This works and renders correct list!!
      // eventClubhouseResponse = await Promise.all(response.data.map(async event => {
      //   if (event.clubhouseID !== undefined) {
      //     let clubhouseResponse = await API.clubhouses.show(event.clubhouseID)
      //     return Object.assign(event, {clubhouse: clubhouseResponse.data})
      //   }
      // }))

      //* Leaving the below examples for the time being so I don't forget them
      //* The can be removed though

      //* does not work but renders correct filtered list items
      // response.data.forEach(async event => {
      //   clubhouseResponse = await API.clubhouses.show(event.clubhouseID)
      //   event.clubhouse = clubhouseResponse.data
      // })

      //* works but renders all items in past list
      // for (let i = 0; i < eventResponse.data.length; i++) {
      //   clubhouseResponse = await API.clubhouses.show(eventResponse.data[i].clubhouseID)
      //   eventResponse.data[i].clubhouse = clubhouseResponse.data
      // }

      //* works but renders all items in past list
      // for (const event of eventResponse.data) {
      //   clubhouseResponse = await API.clubhouses.show(event.clubhouseID)
      //   event.clubhouse = clubhouseResponse.data
      // }
      // console.log(eventResponse)

      //* Not using eventClubhouseResponse now to pull clubhouse info
      // response.data = eventClubhouseResponse
    } catch (err) {
      return new Promise((resolve, reject) => {
        commit(GET_CLUBHOUSE_EVENTS_FAILED);
        reject(err);
      });
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_CLUBHOUSE_EVENTS_FAILED);
        reject(response);
      } else {
        commit(GET_CLUBHOUSE_EVENTS_SUCCESS, response.data);
        // Return GET data within promise
        resolve(response.data);
      }
    }).catch((err) => {
      return console.log('error', err);
    });
  },

  //* delete individual clubhouse card
  async deleteEvent({ commit }, payload) {
    let response;

    commit(DELETE_EVENT);

    try {
      response = await API.events.deleteEvent(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(DELETE_EVENT_FAILED);
        reject(response);
      }

      commit(DELETE_EVENT_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  //* update Connect event
  async updateEvent({ commit, dispatch }, payload) {
    let response = {};

    commit(UPDATE_EVENT);

    try {
      response = await API.events.updateEvent(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(UPDATE_EVENT_FAILED);
        reject(response);
      }

      commit(UPDATE_EVENT_SUCCESS, response.data);

      //* override cached event data
      dispatch('show', { id: response.data.id, overrideCache: true });
      resolve(response.data);
    });
  },
};

// Event mutations
const mutations = {
  [GET_EVENTS](state) {
    state.loading = true;
  },

  [GET_EVENTS_SUCCESS](state, events) {
    state.all = events;
    state.loading = false;
  },

  [GET_EVENTS_FAILED](state) {
    state.loading = false;
  },

  [RESET_EVENTS](state) {
    state.all = [];
    state.totalEvents = 0;
  },

  [GET_CLUBHOUSE_EVENTS](state) {
    state.loadingClubEvents = true;
  },

  [GET_CLUBHOUSE_EVENTS_SUCCESS](state, chEvents) {
    state.clubhouseAll = chEvents;
    state.loadingClubEvents = false;
  },

  [GET_CLUBHOUSE_EVENTS_FAILED](state) {
    state.loadingClubEvents = false;
  },

  [RESET_CLUBHOUSE_EVENTS](state) {
    state.clubhouseAll = [];
  },

  [SHOW_EVENT](state) {
    state.loading = true;
  },

  [SHOW_EVENT_SUCCESS](state, event) {
    state.eventDetails = { ...event };
    state.loading = false;
  },

  [SHOW_EVENT_FAILED](state) {
    state.loading = false;
  },

  [CREATE_EVENT](state) {
    state.loading = true;
  },

  [CREATE_EVENT_SUCCESS](state, event) {
    // Sample Event
    // {
    //   "id": "f25ff418-ada5-4d26-861e-230acc6b6945",
    //   "game_settings_id": "d38a02be-a084-47d3-96ea-3af962d11c73",
    //   "created_at": "2025-02-10T21:19:34.939484916Z",
    //   "updated_at": "2025-02-10T21:19:34.939487575Z",
    //   "clubhouse_id": "5d94bcca-b032-49dc-acac-8584549b1a10",
    //   "player_max": 500,
    //   "starts_at": "2025-02-10T00:01:00-07:00",
    //   "ends_at": "2025-02-17T23:59:00-07:00",
    //   "handicap_max": 54,
    //   "handicap_min": -20,
    //   "creator_id": "169a1c32-05ec-40e8-8e95-6aea87099425",
    //   "status": "active",
    //   "handicap_type": "clubhouse",
    //   "access": "public",
    //   "code": "6B6945"
    // }
    state.createdEvent = event;
    state.loading = false;
  },

  [CREATE_EVENT_FAILED](state) {
    state.createdEvent = {};
    state.loading = false;
  },

  [GET_EVENT_LEADERBOARD](state) {
    state.loadingLeaderboard = true;
  },

  [GET_EVENT_LEADERBOARD_SUCCESS](state, leaderboard) {
    state.eventDetailsLeaderboard = leaderboard;
    state.loadingLeaderboard = false;
  },

  [GET_EVENT_LEADERBOARD_FAILED](state) {
    state.loadingLeaderboard = false;
  },

  [SET_GAME_MODE](state, mode) {
    state.gameMode = mode;
    state.eventDetails.eventTypes = mode;
  },

  [SET_GAME_MODE_EDITABLE](state) {
    state.gameModeEditable = true;
  },

  [SET_EVENT](state, event) {
    state.event = event;
  },

  [SET_EVENT_FAILED](state, event) {
    state.courseSelected = {};
    state.holesSelected = [];
    state.holeNumberSet = [];
  },

  [RESET_EVENT_STATE](state) {
    state = Object.assign(state, emptyState);
  },

  [SET_EVENT_DETAILS](state, eventDetails) {
    state.eventDetails = eventDetails;
  },

  [SET_COURSE](state, course) {
    state.courseSelected = course;
  },

  [CLEAR_SELECTED_COURSE](state) {
    state.courseSelected = {};
  },

  [SET_SELECTED_HOLES](state, holes) {
    state.holesSelected = holes;
  },

  [SET_SELECTED_HOLE_NUMBERS](state, holes) {
    state.holeNumberSet = holes;
  },

  [CLEAR_SELECTED_HOLES](state) {
    state.holesSelected = [];
    state.holeNumberSet = [];
  },

  [SET_GAME_ADDITIONAL_INFORMATION](state, gameInfo) {
    state.gameAdditionalInformation = gameInfo;
  },

  [SET_MEMBERS_SELECTED](state, payload) {
    // const { membersArr, teamsArr } = payload;
    const { membersArr } = payload;
    state.membersSelected = membersArr;
    // state.teamsSelected = teamsArr;
  },

  [TOTAL_EVENTS](state, payload) {
    state.totalEvents = payload;
  },

  [TOTAL_CURRENT_EVENTS](state, payload) {
    state.totalCurrentEvents = payload;
  },

  [DELETE_EVENT](state) {
    state.loading = true;
  },

  [DELETE_EVENT_SUCCESS](state, payload) {
    state.clubhouseAll = state.clubhouseAll.filter((event) => {
      return event.id !== payload.id;
    });
    // state.clubhouseCards = state.clubhouseCards.filter(card => card.id !== payload.id);
    state.loading = false;
  },

  [DELETE_EVENT_FAILED](state) {
    state.loading = false;
  },

  [UPDATE_EVENT](state) {
    state.loading = true;
  },

  [UPDATE_EVENT_SUCCESS](state, payload) {
    state.loading = false;
  },

  [UPDATE_EVENT_FAILED](state) {
    state.loading = false;
  },

  [UPDATE_EVENT_LEADERBOARD](state) {
    state.loadingLeaderboard = true;
  },

  [UPDATE_EVENT_LEADERBOARD_SUCCESS](state, payload) {
    state.loadingLeaderboard = false;
  },

  [UPDATE_EVENT_LEADERBOARD_FAILED](state) {
    state.loadingLeaderboard = false;
  },

  [GET_EVENT_SURVEY_LIST](state) {
    state.generalLoading = true;
  },

  [GET_EVENT_SURVEY_LIST_FAILED](state) {
    state.generalLoading = false;
  },

  [GET_EVENT_SURVEY_LIST_SUCCESS](state, payload) {
    state.generalLoading = false;
    state.eventSurveyList = payload;
  },

  [GET_EVENT_DATA](state) {
    state.generalLoading = true;
  },

  [GET_EVENT_DATA_FAILED](state) {
    state.generalLoading = false;
  },

  [GET_EVENT_DATA_SUCCESS](state, payload) {
    state.generalLoading = false;
  },
};

export default {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
